import { Baggage } from '@websky/core/src/BaggageService/types';

export const REDWINGS_SORTING = [
	// Snow board
	'0EG',
	'0EH',
	'0DD',
	'0HS',
	// Serfing
	'0EI',
	// Bike
	'0EF',
	'0EC',
	// Musical
	'0PR',
	// Small pet
	'021',
	// Medium pet
	'0BS',
	// Pet in hold
	'0BT',
	// Big pet
	'0AY'
];

export const specialEquipmentItemsSort = (a: Baggage[], b: Baggage[]) => {
	return (
		REDWINGS_SORTING.findIndex(value => value === a[0]?.rfics) -
		REDWINGS_SORTING.findIndex(value => value === b[0]?.rfics)
	);
};
